import React, {useState, useEffect, useRef} from 'react'
import {Button} from '@mui/material'
import useTitle from '../../hooks/title'
import classes from './VocalNetZh.module.scss'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import {ReactComponent as Windows} from '../../images/windows.svg'
import {ReactComponent as Mac} from '../../images/mac.svg'
import {ReactComponent as Msg} from '../../images/msg.svg'
import useWindowSize from '../../hooks/window-size';
import clsx from 'clsx'
import layoutStyles from '../layout/Layout.module.scss'
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import LoadingButton from '@mui/lab/LoadingButton';
import {observer, useLocalObservable} from "mobx-react-lite";
import {createApi} from "../common/API";
import Dialog from "@mui/material/Dialog";
import QR from '../../images/contact-qr.jpg';
import CancelIcon from '@mui/icons-material/Cancel';
import Backdrop from '@mui/material/Backdrop';
import pcMp4 from '../../images/pc/vocalnet.mp4'
import mbMp4 from '../../images/mb/vocalnet.mp4'
import tutorial1 from '../../images/pc/vocalnet1.mp4'
import tutorial2 from '../../images/pc/vocalnet2.mp4'
import tutorial3 from '../../images/pc/vocalnet3.mp4'
import araImg from '../../images/ara.png'
import vocalnetMapImg from '../../images/pc/vocalnet.png'
import vocalnetArtistMapImg from '../../images/pc/vocalnet-artist.png'
// Inputs
import src0 from '../../audios/src1.mp3';
import src1 from '../../audios/src2.mp3';
import src2 from '../../audios/src3.mp3';

// Targets
import ref0 from '../../audios/ref1.mp3';
import ref1 from '../../audios/ref2.mp3';
import ref2 from '../../audios/ref3.mp3';

// Outputs
import out0 from '../../audios/out1.mp3';
import out1 from '../../audios/out2.mp3';
import out2 from '../../audios/out3.mp3';

// Artist images
import belaroImg from '../../images/artists/belaro.jpg';
import blackbirdImg from '../../images/artists/blackbird.jpg';
import boyBeverlyImg from '../../images/artists/boy-beverly.jpg';

const artists = [
    {
        name: 'BELARO',
        title: '歌手',
        description: 'BELARO，新兴R&B明星，融合Y2K风格灵魂乐与现代边缘，带来震撼人声和病毒式传播的表演。',
        image: belaroImg,
    },
    {
        name: 'Blackbird',
        title: '艺人、歌手、词曲作者',
        description: '来自塞浦路斯的音乐家，融合东西方文化，结合地中海之美与流行能量，重新打造文化流行音乐。',
        image: blackbirdImg,
    },
    {
        name: 'Boy Beverly',
        title: '歌手',
        description: '从费城到洛杉矶，Boy Beverly将成长与情感融入音乐，超越声音，创造共同体验。',
        image: boyBeverlyImg,
    },
];

const userRegister = createApi('/user/register', {method: 'POST', expandData: true, notify: true, noThrow: false});
const createOrderWithCode = createApi('/app/createOrderWithCode', {method: 'POST', expandData: true, notify: true, noThrow: false})
const showApp = createApi('/app/getApps', {method: 'POST', expandData: true, notify: true, noThrow: false});

const VocalNetZh = () => {
    console.log('run VocalNet zh')
    const [version, setVersion] = useState('');
    useTitle("VocalNet - 实时克隆与变换人声")
    const windowSize = useWindowSize();
    const [isPlaying, setIsPlaying] = useState(false);
    const playerRef = useRef(null);
    const [activeDot, setActiveDot] = useState(null);
    const dots = [
        { id: 'voice',     top: '21.3%', left: 'calc(50% - 6px)', title: '加载人声', desc: '加载预置或导入人声样本到槽位。VocalNet会分析并将您的输入转换为匹配目标人声。您最多可以加载三个人声。为获得最佳效果，请使用5-10秒长的样本。' },
        { id: 'cursor', top: '54%', left: 'calc(50% - 6px)', title: '人声融合', desc: '拖动光标在人声之间混合，创造独特的音色。' },
        { id: 'mode', top: '6%', left: '83%', title: '选择渲染模式', desc: '选择捕获模式进行实时转换，或选择文件模式以最佳质量离线渲染。' },
        { id: 'switch', top: '6%', left: 'calc(50% - 6px)', title: '切换模式', desc: '将光标移到这里，可在混合模式和艺人模式之间切换。' },
    ];
    const artistDots = [
        { id: 'artist', top: '16.3%', left: 'calc(50% - 6px)', title: '切换艺人', desc: '选择“我的艺人”查看已安装或已购买的人声。选择“全部艺人”浏览所有可用艺人，包括免费人声。' },
        { id: 'buy', top: '53%', left: '83%', title: '购买艺人人声', desc: '点击按钮打开所选艺人人声的购买页面。' },
        { id: 'redeem', top: '16%', left: '83%', title: '兑换艺人人声', desc: '购买后，点击按钮并在弹窗中粘贴兑换码，即可解锁该艺人人声。' },
    ];

    const state = useLocalObservable(() => ({
        showQR: false,
        openQR() {
            this.showQR = true
        },
        closeQR() {
            this.showQR = false
        }
    }))
    
    const form = useLocalObservable(() => ({
        email: '',
        password: '',
        code: '',
        posting: false,
        immediately: false,
        errors: {email: null, password: null, code: null},
        success: false,
        handleEmail(e) {
            this.email = e.target.value.trim()
            this.immediately && this.validEmail()
        },
        handlePassword(e) {
            this.password = e.target.value.trim()
            this.immediately && this.validPassword()
        },
        handleCode(e) {
            this.code = e.target.value.trim()
            this.immediately && this.validCode()
        },
        validEmail() {
            if (this.email.length < 1) {
                this.errors.email = '请输入邮箱'
                return false
            }
            const pattern = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/g
            if (!(pattern.test(this.email.toString()))) {
                this.errors.email = '请输入正确邮箱'
                return false
            }
            this.errors.email = null
            return true
        },
        validPassword() {
            if (this.password.length < 1) {
                this.errors.password = '请输入密码'
                return false
            }
            if (this.password.length < 8) {
                this.errors.password = '密码不能少于8位'
                return false
            }
            this.errors.password = null
            return true
        },
        validCode() {
            if (this.code.length < 1) {
                this.errors.code = '请输入兑换码'
                return false
            }
            this.errors.code = null
            return true;
        },
        handleKeyup(e) {
            if(e.keyCode === 13) {
                this.handleSubmit()
            }
        },
        async handleSubmit() {
            this.posting = true
            this.immediately = true
            const ck = [this.validEmail(), this.validPassword(), this.validCode()]
            if (ck.some(c => !c)) {
                this.posting = false
                console.log('校验失败....')
                return;
            }

            try {
                await userRegister({email: this.email, password: this.password})
            } catch (e) {
                console.log('reg fail', e)
                this.errors.email = '注册失败'
                this.posting = false
                return;
            }

            try {
                await createOrderWithCode({appId: 'VocalNet', code: this.code})
                this.success = true
                this.email = ''
                this.password = ''
                this.code = ''
            } catch (e) {
                console.log('code fail', e)
                this.errors.code = '兑换失败'
            }
            this.posting = false
        },
    }));

    const isNearTop = (topPercent) => {
        const topValue = parseInt(topPercent);
        return topValue < 30;
    };

    const handlePlayClick = () => {
        if (windowSize.width < 500)
        setIsPlaying(true);
    };

    const handleOverlayClick = (e) => {
        if (playerRef.current && !playerRef.current.contains(e.target)) {
            setIsPlaying(false);
        }
        if (isPlaying) 
            setIsPlaying(false);
    };

    const handleMapClick = (e) => {
        if (e.target.classList.contains(classes.map)) {
            setActiveDot(null);
        }
    };

    const handleTooltipClick = (e) => {
        e.stopPropagation();
    };

    const audioRefs = useRef([]);
    const [playingIndex, setPlayingIndex] = useState(-1);

    const handlePlay = (idx) => {
        audioRefs.current.forEach((a, i) => {
            if (a && i !== idx) {
                a.pause();
                a.currentTime = 0;
            }
        });
        setPlayingIndex(idx);
    };

    const handleEnded = () => setPlayingIndex(-1);

    useEffect(() => {
        window.scrollTo(0, 0)
        const fetchApiData = async () => {
            try {
              const response = await showApp();
              setVersion(response[4].version)
            } catch (error) {
              console.error('Error fetching API data:', error);
            }
          };
        fetchApiData()
    }, [])

    useEffect(() => {
        const handleEnded = () => setPlayingIndex(-1);
        const audios = audioRefs.current;
        audios.forEach(a => a && a.addEventListener("ended", handleEnded));
        return () => {
            audios.forEach(a => a && a.removeEventListener("ended", handleEnded));
        };
    }, []);

    const mp4 = windowSize.width > 500 ? pcMp4 : mbMp4;

    return <div className={clsx(classes.root, layoutStyles.root)}>
    <div className={classes.seg}>
        <video autoPlay loop muted playsInline>
            <source src={mp4} type="video/mp4" />
        </video>

        <div className={classes.introduction}>
            <h1>VocalNet</h1>
            <p>实时歌声转换效果器</p>
        </div>
    </div>
      <Backdrop open={isPlaying} onClick={handleOverlayClick} />
        <div className={classes.options} >
            <div className={clsx(classes.option, classes.white)}  style={windowSize.width < 500 ? {paddingLeft: 'calc(35vw + 2px)'} : {}}
                onClick = {() => document.getElementById("buys").scrollIntoView({block:"center", behavior:"smooth"})}>
                <ShoppingCartIcon/>
                <div className={classes.optionText} style={windowSize.width < 500 ? {marginLeft : 22} : {}}>产品兑换</div>
            </div>
            <div className={clsx(classes.option, classes.white)} style={windowSize.width < 500 ? {borderTop: '1.5px solid white', borderBottom: '1.5px solid white'} :
            {borderLeft: '1.5px solid white', borderRight: '1.5px solid white'}}
                onClick = {() => document.getElementById("downloads").scrollIntoView({block:"center", behavior:"smooth"})}
            >
                <SaveAltIcon style={{fontSize: 28}}/>
                <div className={classes.optionText}>{windowSize.width < 500 ? '免费下载' : '免费下载'}</div>
            </div>
            <Dialog onClose={() => state.closeQR()} open={state.showQR} classes={{paper:classes.qrPaper}}>
                <CancelIcon className={classes.closeIcon} onClick={() => state.closeQR()} />
                <img src={QR} width={200}  alt="联系我们"/>
            </Dialog>
            <div className={clsx(classes.option, classes.white)} onClick={() => state.openQR()}>
                <Msg style={{width: 27, height: 27}}/>
                <div className={classes.optionText}>{windowSize.width < 500 ? '联系我们' : '联系我们'}</div>
            </div>
        </div>
        <div className={classes.content}>
            <div className={classes.walkthrough}>
                <div className={classes.title}>VocalNet如何工作</div>
                {/* <div className={classes.videoContainer}>
                    <iframe
                        src="https://www.youtube.com/embed/zIMh8gt_ucU?si=lDriZ9VSSocrWESI"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    />
                </div>
                <div className={classes.subTitle} style={{marginTop: 60}}>两种模式可选</div> */}
                <div className={classes.tutorial} style={{marginTop: windowSize.width < 500 ? 60 : 120}} >
                    <div
                        className={classes.map}
                        style={{ backgroundImage: `url(${vocalnetMapImg})` }}
                        onClick={handleMapClick}
                    >
                        {dots.map(dot => (
                            <div key={dot.id}
                                className={classes.dot}
                                style={{ top: dot.top, left: dot.left }}
                                onClick={() => setActiveDot(activeDot === dot.id ? null : dot.id)}
                            />
                        ))}
                        {dots.map(dot => (
                            activeDot === dot.id ? (
                                <div key={dot.id + '-tip'}
                                    className={clsx(classes.tooltip, isNearTop(dot.top) && classes.tooltipBelow)}
                                    style={{ top: dot.top, left: dot.left }}
                                    onClick={handleTooltipClick}
                                >
                                    <div className={classes.title}>{dot.title}</div>
                                    <div className={classes.desc}>{dot.desc}</div>
                                </div>
                            ) : null
                        ))}
                    </div>
                    <div className={classes.tutorialText}>
                        <div className={classes.tutorialTitle}>混合模式</div>
                        <div className={classes.tutorialDesc}>
                            加载最多三个人声，然后拖动光标实时混合它们，创造独特的音色。
                        </div>
                    </div>
                </div>
                <div className={classes.tutorial} style={{marginTop: windowSize.width < 500 ? 60 : 120}} >
                    <div
                        className={clsx(classes.map, classes.mapArtist)}
                        style={{ backgroundImage: `url(${vocalnetArtistMapImg})` }}
                        onClick={handleMapClick}
                    >
                        {artistDots.map(dot => (
                            <div key={dot.id}
                                className={classes.dot}
                                style={{ top: dot.top, left: dot.left }}
                                onClick={() => setActiveDot(activeDot === dot.id ? null : dot.id)}
                            />
                        ))}
                        {artistDots.map(dot => (
                            activeDot === dot.id ? (
                                <div key={dot.id + '-tip'}
                                    className={clsx(classes.tooltip, isNearTop(dot.top) && classes.tooltipBelow)}
                                    style={{ top: dot.top, left: dot.left }}
                                    onClick={handleTooltipClick}
                                >
                                    <div className={classes.title}>{dot.title}</div>
                                    <div className={classes.desc}>{dot.desc}</div>
                                </div>
                            ) : null
                        ))}
                    </div>
                    <div className={classes.tutorialText}>
                        <div className={classes.tutorialTitle}>艺人模式</div>
                        <div className={classes.tutorialDesc}>
                            您可以免费试用合作艺人的人声。如果某个人声适合您的项目，请购买使用，核心收益会直接归艺人所有。
                        </div>
                    </div>
                </div>
            </div>
            <div className={classes.subTitle}>三步完成人声克隆与变换</div>
            <div className={classes.tutorial}>
                <div className={classes.tutorialVideo}>
                    <video className={classes.videoFrame} autoPlay loop muted playsInline>
                        <source src={tutorial1} type="video/mp4" />
                    </video>
                </div>
                <div className={classes.tutorialText}>
                    <div className={classes.tutorialTitle}>1. 导入人声样本</div>
                    <div className={classes.tutorialDesc}>
                        VocalNet会分析导入的样本并将其克隆为目标人声。样本越干净、处理越少，转换质量越高。
                    </div>
                </div>
            </div>

            <div className={classes.tutorial}>
                {windowSize.width < 500 ? 
                <React.Fragment>
                <div className={classes.tutorialVideo}>
                <video className={classes.videoFrame} autoPlay loop muted playsInline>
                    <source src={tutorial2} type="video/mp4" />
                </video>
                </div>
                <div className={classes.tutorialText}>
                    <div className={classes.tutorialTitle} style={{textAlign: 'left'}}>2. 变换输入人声</div>
                    <div className={classes.tutorialDesc} style={{textAlign: 'left'}}>
                        在音轨上开始播放——VocalNet将作为音频效果实时转换输入以匹配目标人声。
                    </div>
                </div></React.Fragment> : 
                <React.Fragment>
                <div className={classes.tutorialText}>
                    <div className={classes.tutorialTitle} style={{textAlign: 'right'}}>2. 变换输入人声</div>
                    <div className={classes.tutorialDesc} style={{textAlign: 'right'}}>
                        在音轨上开始播放——VocalNet将作为音频效果实时转换输入以匹配目标人声。
                    </div>
                </div>
                <div className={classes.tutorialVideo}>
                    <video className={classes.videoFrame} autoPlay loop muted playsInline>
                        <source src={tutorial2} type="video/mp4" />
                    </video>
                </div></React.Fragment>}
            </div>

            <div className={classes.tutorial}>
                <div className={classes.tutorialVideo}>
                    <video className={classes.videoFrame} autoPlay loop muted playsInline>
                        <source src={tutorial3} type="video/mp4" />
                    </video>
                </div>
                <div className={classes.tutorialText}>
                    <div className={classes.tutorialTitle}>3. 人声融合</div>
                    <div className={classes.tutorialDesc}>
                        加载最多三个人声，然后拖动光标实时混合它们，创造独特的音色。
                    </div>
                </div>
            </div>
            <div className={classes.subTitle}>完整 DAW 集成，支持 ARA</div>
            <div className={classes.araSection}>
                <img src={araImg} alt="完整 DAW 集成，支持 ARA" className={classes.araImage} />
                <div className={classes.araDescription}>
                    VocalNet 支持兼容 DAW 中的 ARA 工作流，让您可以直接在音轨时间线上编辑，获得更快速、更紧密的集成和更流畅的制作体验。
                </div>
            </div>
            <div className={classes.subTitle}>试听效果</div>
            <div className={classes.audioGrid}>
            {windowSize.width > 900 && (
                <div className={classes.audioHead}>
                <div className={classes.audioColTitle}>输入</div>
                <div className={classes.audioColTitle}>目标</div>
                <div className={classes.audioColTitle}>输出</div>
                </div>
            )}
            {[0, 1, 2].map(r => (
                <div key={r} className={classes.audioRowWrap}>
                {windowSize.width <= 900 && (
                    <div className={classes.audioColTitle}>输入</div>
                )}
                <audio
                    className={classes.audioPlayer}
                    controls
                    controlsList="nodownload noplaybackrate noremoteplayback"
                    src={[src0, src1, src2][r]}
                    ref={el => (audioRefs.current[r * 3 + 0] = el)}
                    onPlay={() => handlePlay(r * 3 + 0)}
                    onEnded={handleEnded}
                />
                {windowSize.width <= 900 && (
                    <div className={classes.audioColTitle}>目标</div>
                )}
                <audio
                    className={classes.audioPlayer}
                    controls
                    controlsList="nodownload noplaybackrate noremoteplayback"
                    src={[ref0, ref1, ref2][r]}
                    ref={el => (audioRefs.current[r * 3 + 1] = el)}
                    onPlay={() => handlePlay(r * 3 + 1)}
                    onEnded={handleEnded}
                />
                {windowSize.width <= 900 && (
                    <div className={classes.audioColTitle}>输出</div>
                )}
                <audio
                    className={classes.audioPlayer}
                    controls
                    controlsList="nodownload noplaybackrate noremoteplayback"
                    src={[out0, out1, out2][r]}
                    ref={el => (audioRefs.current[r * 3 + 2] = el)}
                    onPlay={() => handlePlay(r * 3 + 2)}
                    onEnded={handleEnded}
                />
                </div>
            ))}
            </div>
            <div className={classes.downloadTips}>
                <div className={classes.downloadTipsTitle}>VocalNet</div>
                <div className={classes.downloadTipsAction}>免费下载</div>
            </div>
            <div id="downloads" className={classes.downloads}>
                <div className={classes.download}>
                    <Button startIcon={<Windows style={{marginLeft: 7, marginRight: 10}}/>} variant="contained" className={classes.button}  href="https://sessionloops.oss-cn-beijing.aliyuncs.com/VocalNet_Installer.exe" target="_blank">Windows下载</Button>
                    最新版本 {version}，Windows 7 及更高
                </div>
                <div className={classes.download}>
                    <Button startIcon={<Mac style={{marginLeft: 7, marginRight: 10}}/>} variant="contained" className={classes.button}  href="https://sessionloops.oss-cn-beijing.aliyuncs.com/VocalNet_Installer.pkg" target="_blank">Mac下载</Button>
                    最新版本 {version}，macOS 10.14 及更高，全芯片支持
                </div>
            </div>
            <div className={classes.text}>您可以免费试用所有功能14天。之后人声克隆功能将被禁用。<br />
                要访问完整版本，请在下方兑换授权。</div>
            <div id="buys" className={classes.exchange}>
                <FormControl className={clsx(classes.field)}>
                    <OutlinedInput
                        name="email"
                        size="small"
                        placeholder="邮箱"
                        value={form.email}
                        onChange={form.handleEmail}
                        onKeyUp={form.handleKeyup} />
                </FormControl>
                <FormControl className={clsx(classes.field)}>
                    <OutlinedInput
                        name="password"
                        size="small"
                        type="password"
                        placeholder="密码：不少于8位"
                        value={form.password}
                        onChange={form.handlePassword}
                        onKeyUp={form.handleKeyup} />
                </FormControl>
                <FormControl className={clsx(classes.field)}>
                    <OutlinedInput
                        name="code"
                        size="small"
                        placeholder="兑换码"
                        value={form.code}
                        onChange={form.handleCode}
                        onKeyUp={form.handleKeyup} />
                </FormControl>
                <div className={clsx(classes.tipsMsg, form.success ? classes.tipsMsgSucc : classes.tipsMsgErr)}>
                    {(form.success && '兑换成功!请在App内激活！') || form.errors.email || form.errors.password || form.errors.code || ''}
                </div>
                <LoadingButton
                    className={classes.submit}
                    variant="contained"
                    disableElevation
                    loading={form.posting}
                    onClick={form.handleSubmit}
                >兑换</LoadingButton>
            </div>
        </div>
        <div className={classes.copyright}></div>
      </div>
  }

  export default observer(VocalNetZh)
